import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "i18n";
import { GlobalStyles, ThemeProvider } from "themes";
import AssetsProvider from "hooks/AssetsProvider";
import { createLogger as createReduxLogger } from "redux-logger";
import { createStore, applyMiddleware, compose } from "redux";
import { reducer } from "./state";
import { Provider as ReduxProvider } from "react-redux";
import { REDUX_LOGGER } from "environment";
import { createAnalyticsMiddleware } from "./analytics/portfolioReduxAnalytics";

const loggerMiddleware = createReduxLogger({
  collapsed: true,
  duration: true,
  diff: false,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = REDUX_LOGGER
  ? composeEnhancers(
      applyMiddleware(loggerMiddleware),
      applyMiddleware(createAnalyticsMiddleware())
    )
  : composeEnhancers(applyMiddleware(createAnalyticsMiddleware()));

const store = createStore(reducer, middleware);

const Providers = ({ children }) => {
  return (
    <ReduxProvider store={store}>
      <GlobalStyles />
      <LanguageProvider>
        <ThemeProvider>
          <AssetsProvider>
            <BrowserRouter>{children}</BrowserRouter>
          </AssetsProvider>
        </ThemeProvider>
      </LanguageProvider>
    </ReduxProvider>
  );
};

Providers.propTypes = {
  children: PropTypes.any,
};
export default Providers;
